<template lang="pug">
  .col-12.lg-gutter.anim-fade(class="md:col-6" @click.prevent="$emit('click', place)")
    .mb-8.text-center.cursor-pointer(class="md:mb-16")
      .overflow-hidden.guide-svg
        img(
          v-if="place.attributes.cover_picture_url"
          :src="place.attributes.cover_picture_url" class="img-cover img-zoom h-100"
        )
        div(
          :style="randomBackgroundColor"
          class="flex items-center justify-center h-100"
          v-else=""
        )
          slot(
            name="placeholder"
          )
      .p-5.thumb-bordered--secondary
        h2.h3.font-bold.cursor-pointer.thumb-bordered__title {{ place.attributes.title }}
        .font-medium.leading-13.cursor-pointer.thumb-bordered__title(v-html="place.attributes.description")
        h5.mx-auto.link-primary.cursor-pointer.font-medium.text-center.mt-2.cursor-pointer.link-underline-fill-primary Lire la suite
</template>

<script>
export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  },

  computed: {
    randomBackgroundColor () {
      const colors = ["#171C44", "#bba640", "#e782aa", "#18332f"]
      const randomColor = colors[Math.floor(Math.random() * colors.length)]
      return `background-color: ${randomColor};`
    }
  }
}
</script>
